"use client"

import { useEffect } from "react"
import { useParams, usePathname, useSearchParams } from "next/navigation"
import { useUbStorefrontState } from "@/store/ubStorefrontState"

export default function Loading() {
  const { isLoading, setIsLoading } = useUbStorefrontState()

  const pathname = usePathname()
  const searchParams = useSearchParams()
  const params = useParams()

  useEffect(() => {
    setIsLoading(false)
  }, [pathname, searchParams, params, setIsLoading])

  return (
    <div className="pointer-events-none fixed inset-0 z-above-all size-full">
      {isLoading && (
        <>
          <div className="pointer-events-auto fixed size-full bg-black opacity-50"></div>
          <div className="pointer-events-auto flex size-full items-center justify-center">
            <div className="loading absolute opacity-100"></div>
          </div>
        </>
      )}
    </div>
  )
}
